import { isDevMode } from "../../helpers/helpers.ts";
import { useVehicleSelection } from "../../providers/VehicleSelectionContext.tsx";
import { DebugClearCart } from "./DebugClearCart.tsx";
import { DebugViewCart } from "./DebugViewCart.tsx";

export const DevTools = () => {
  const { orderMode } = useVehicleSelection();

  if (!isDevMode) {
    return null;
  }

  if (orderMode !== "new") {
    return null;
  }

  return (
    <div className="flex gap-2">
      <DebugViewCart />
      <DebugClearCart />
    </div>
  );
};
